export default __webpack_public_path__ + "02471c5a9721f2d4de3204b2163b03e9.svg";